// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuListSubheadig_root__BboOi","container":"MenuListSubheadig_container__huvFo","title":"MenuListSubheadig_title__v8GxN","after":"MenuListSubheadig_after__YKnse"};